<template>
  <div class="ebook-content-section">
    <div class="content-container">
      <!-- Columna izquierda: Imagen del magazine mockup -->
      <div class="content-image-column">
        <div class="magazine-stack">
          <img
            src="@/assets/images/magazinemockup.png"
            alt="Ebook: Del Excel al mantenimiento inteligente - Contenido"
            class="magazine-image"
          />
        </div>
      </div>

      <!-- Columna derecha: Contenido -->
      <div class="content-text-column">
        <div class="content-header">
          <div class="section-badge">
            <div class="badge-line"></div>
            <span class="badge-text">CONTENIDO DEL EBOOK</span>
          </div>
          <h2 class="main-title">Lo que aprenderás en esta guía</h2>
        </div>

        <p class="intro-text">
          Un recorrido práctico desde el diagnóstico en Excel hasta el go-live en un sistema de
          mantenimiento inteligente.
        </p>

        <ul class="content-list">
          <li class="content-item">
            <div class="number-icon">
              <span class="number">1</span>
            </div>
            <span>Introducción: ¿Por qué cambiar?</span>
          </li>
          <li class="content-item">
            <div class="number-icon">
              <span class="number">2</span>
            </div>
            <span>El costo oculto de seguir en Excel</span>
          </li>
          <li class="content-item">
            <div class="number-icon">
              <span class="number">3</span>
            </div>
            <span>¿Qué es el mantenimiento inteligente?</span>
          </li>
          <li class="content-item">
            <div class="number-icon">
              <span class="number">4</span>
            </div>
            <span>Cómo dar el salto: de Excel a Fourin Track</span>
          </li>
          <li class="content-item">
            <div class="number-icon">
              <span class="number">5</span>
            </div>
            <span>Caso práctico: Escenario realista de empresa del sector alimentos</span>
          </li>
        </ul>

        <button class="download-cta" @click="scrollToForm">
          <span>Descargar ebook</span>
          <svg class="cta-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M7 17L17 7M17 7H7M17 7V17"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const scrollToForm = () => {
  const formElement = document.querySelector('.ebook-form-section')
  if (formElement) {
    formElement.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<style scoped>
.ebook-content-section {
  padding: 80px 20px;
  background: white;
  min-height: 60vh;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.content-image-column {
  display: flex;
  justify-content: center;
  align-items: center;
}

.magazine-stack {
  position: relative;
  width: 100%;
  max-width: 650px;
}

.magazine-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.1));
}

.content-text-column {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.content-header {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-badge {
  display: flex;
  align-items: center;
  gap: 12px;
}

.badge-line {
  width: 40px;
  height: 2px;
  background: #129bef;
}

.badge-text {
  color: #129bef;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.main-title {
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 600;
  color: #333;
  line-height: 1.2;
  margin: 0;
}

.intro-text {
  font-size: 18px;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

.content-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.number-icon {
  width: 32px;
  height: 32px;
  background: #129bef;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.number-icon .number {
  color: white;
  font-size: 16px;
  font-weight: 600;
}

.content-item span {
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  font-weight: 500;
}

.download-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #129bef;
  color: white;
  border: none;
  padding: 18px 36px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: fit-content;
  margin-top: 20px;
}

.download-cta:hover {
  background: #0ea5e9;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(18, 155, 239, 0.4);
}

.cta-arrow {
  transition: transform 0.3s ease;
}

.download-cta:hover .cta-arrow {
  transform: translate(2px, -2px);
}

@media (max-width: 1024px) {
  .content-container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }

  .content-image-column {
    order: -1;
  }

  .magazine-stack {
    max-width: 400px;
  }
}

@media (max-width: 768px) {
  .ebook-content-section {
    padding: 60px 15px;
  }

  .content-container {
    gap: 30px;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .intro-text {
    font-size: 16px;
  }

  .content-item {
    text-align: left;
  }

  .download-cta {
    width: 100%;
    padding: 16px 32px;
    font-size: 16px;
  }

  .magazine-stack {
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .ebook-content-section {
    padding: 40px 10px;
  }

  .content-list {
    gap: 16px;
  }

  .content-item span {
    font-size: 15px;
  }

  .magazine-stack {
    max-width: 250px;
  }
}
</style>
